export default __webpack_public_path__ + "static/media/search-12.9e1a9035.svg";